module.exports = __webpack_public_path__ + "static/media/sint-maarten.dde608cd.png";